
import axios from 'axios';
import React, { useState, useEffect,useRef, useMemo} from 'react';
import {getCookie,getCsrfToken} from './get_csrfToken'

const custom_api_func2 = axios.create({
    baseURL: 'https://api.successguardian.in/',
    withCredentials: true
});



export default custom_api_func2;